import u from "@babel/runtime/helpers/esm/objectSpread2";
import { sstyled as C, assignProps as d } from "@semcore/core";
import t from "react";
import { Box as v, Flex as h } from "@semcore/flex-box";
import x from "@semcore/icon/MathPlus/m";
import E, { PaletteManager as P } from "../ColorPicker.mjs";
function M(e) {
  var i = arguments[0], r, l = e.Children, s = e.styles, o = e.colors, c = e.getI18nText, n = v;
  return r = C(s), /* @__PURE__ */ t.createElement(n, r.cn("SColors", u({}, d({
    role: "listbox",
    "aria-orientation": "horizontal",
    "aria-label": c("presetColors")
  }, i))), l.origin ? /* @__PURE__ */ t.createElement(l, r.cn("Children", {})) : o == null ? void 0 : o.map(function(a) {
    return /* @__PURE__ */ t.createElement(E.Item, {
      value: a,
      key: a
    });
  }));
}
function _(e) {
  var i = arguments[0], r, l = e.Children, s = e.styles, o = e.colors, c = e.onPlusButtonClick, n = e.getI18nText, a = v, f = h, g = "div";
  return r = C(s), /* @__PURE__ */ t.createElement(f, r.cn("SColorsContainer", {}), /* @__PURE__ */ t.createElement(a, r.cn("SColors", u({}, d({
    role: "listbox",
    "aria-orientation": "horizontal",
    "aria-label": n("customColors")
  }, i))), l.origin ? /* @__PURE__ */ t.createElement(l, r.cn("Children", {})) : o == null ? void 0 : o.map(function(m) {
    return /* @__PURE__ */ t.createElement(P.Item, {
      value: m,
      key: m
    });
  })), /* @__PURE__ */ t.createElement(g, r.cn("SPlusButton", {
    onClick: c,
    role: "button",
    "aria-label": n("addColor")
  }), /* @__PURE__ */ t.createElement(x, r.cn("MathPlusM", {
    color: "icon-primary-neutral"
  }))));
}
export {
  M as Colors,
  _ as ColorsCustom
};
